<template>
  <div
    class="modal fade"
    id="galleryViewerModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="galleryViewerModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="thumbnail-container h-100">
            <template v-for="(image, index) in reportImages">
              <img
                :src="image"
                :key="index"
                :class="{ selected: index === imageIndex }"
                @click="imageIndex = index"
              />
            </template>
          </div>
          <div class="image-container h-100 position-relative">
            <img :src="reportImages[imageIndex]" />
            <div v-if="caption" class="image-caption p-3">{{caption}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "galleryViewer",
  props: ["images", "currentImageIndex", "showModal", "caption"],
  data() {
    return {
      imageIndex: 0,
      reportImages: []
    };
  },
  watch: {
    showModal() {
      if (this.showModal) {
        this.imageIndex = this.currentImageIndex;
        this.reportImages = this.images;
        $("#galleryViewerModal").modal("show");
      } else {
        $("#galleryViewerModal").modal("hide");
        this.imageIndex = 0;
        this.reportImages = [];
      }
    }
  },
  mounted() {
    let vm = this;
    $("#galleryViewerModal").on("hide.bs.modal", function(e) {
      vm.$emit("toggleModal", "galleryViewer", false);
    });
  }
};
</script>

<style lang="scss" scoped>
.image-caption {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  background-color: #00000057;
  color: #f5f7fa;
  max-height: 80px;
  overflow-y: auto;
}

.thumbnail-container {
  img:not(.selected) {
    transform: scale(0.8);
  }

  img.selected {
    box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.3);
  }
}

.close {
  position: absolute;
  right: 0px;
  top: 0px;
  font-size: 2rem;
  color: #000000;
  padding: 0.4rem 1rem;
  border-radius: 4px;
  opacity: 1;
  z-index: 10;
}

.modal {
  overflow: hidden !important;
  font-size: 1rem !important;
  z-index: 2147483647;
}

.modal-dialog {
  max-width: 100% !important;
  width: 100%;
  height: 100%;
  margin: 0px;
}

.modal-content {
  width: 100%;
  height: 100%;
  background-color: #f5f7fa;
  border: none;
  border-radius: 0px;
}

.modal-body {
  display: flex;
  flex: unset;
  width: 100%;
  height: 100%;
  padding: 0px;
}

.thumbnail-container {
  width: 140px;
  overflow-y: scroll;
  background-color: #eff2f6;
  padding: 20px;

  img {
    width: 100%;
    height: auto;
    margin-bottom: 1rem;
    border-radius: 4px;
    transition: all 0.3s;

    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  }
}

.image-container {
  flex-grow: 1;
  padding-left: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;

  img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
